<template>
  <div style="position: relative">
    <iframe v-if="this.version!=''" id="baidutongji" name="baidutongji"
      :src="`https://aiplugin.5118.com/Pluginstat/?p=checksiteinbaidu&v=${version}`"
      style="width: 0px; height: 0px; position: fixed; transform: translateY(-9999px);"></iframe>
    <div dir="rtl" class="page" style="height: 100%;">
      <div dir="ltr">
        <p class="checkdomainname" :title="getdomain">当前域名【{{getdomain}}】</p>
        <div class="row" style="margin: 10px 0;">
          <div class="col-15 left">
            <button class="btn" @click="checkBaiduSite" :disabled="loading">{{loading?"查询中...":"点击查收录"}}</button>
          </div>
          <div class="col-15 right">
            <button class="btn is-plain" @click="exportList">
              <img src="../assets/image/export_ico.png" style="vertical-align: middle">
              导出数据
            </button>
          </div>
        </div>
        <table class="baidusite-count-table" style="table-layout: fixed">
          <thead>
          <tr>
            <th>收录数量</th>
            <th>未收录</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td style="color: green;cursor: pointer;padding-left: 10px;" @click="filterType=`是`">{{isOkNum}}</td>
            <td style="color: red;cursor: pointer;padding-left: 10px;" @click="filterType=`否`">{{isBadNum}}</td>
          </tr>
          </tbody>
        </table>
        <table class="baidusite-table" style="table-layout: fixed">
          <thead>
          <tr>
            <th>链接词</th>
            <th>是否收录</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in items" :key="index" v-show="filterType===null||filterType===item.type">
            <td @click="$open('https://www.baidu.com/s?wd='+item.url)" :title="item.keyword" style="cursor: pointer;">{{item.keyword}}</td>
            <td :style="{color:item.type===`是`?`green`:`red`}" style="padding-left: 10px;">{{item.type}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapActions} from "vuex"

  export default {
    name: "BaiduSite",
    data() {
      return {
        filterType: null
      }
    },
    computed: {
      isShow: {
        get() {
          return this.$store.state.baiduSite.isShow
        },
        set(val) {
          this.$store.state.baiduSite.isShow = val
        }
      },
      loading: {
        get() {
          return this.$store.state.baiduSite.loading
        },
        set(val) {
          this.$store.state.baiduSite.loading = val
        }
      },
      items: {
        get() {
          return this.$store.state.baiduSite.items
        },
        set(val) {
          this.$store.state.baiduSite.items = val
        }
      },
      isOkNum: {
        get() {
          return this.$store.state.baiduSite.isOkNum
        },
        set(val) {
          this.$store.state.baiduSite.isOkNum = val
        }
      },
      isBadNum: {
        get() {
          return this.$store.state.baiduSite.isBadNum
        },
        set(val) {
          this.$store.state.baiduSite.isBadNum = val
        }
      },
      version:{
        get(){
          return this.$store.state.menu.version
        },
        set(val){
          this.$store.state.menu.version = val
        }
      },
      getdomain: {
        get() {
          return this.$store.state.menu.jump_domain_url;
        }
      }
    },
    mounted() {
      this.ASetHistory("baidusite").then(flag => {
        if (flag) {
          this.listenBaiduSite();
        }
      });
    },
    methods: {
      ...mapActions("menu", ["ASetHistory"]),
      checkBaiduSite() {
        if (this.loading) {
          return;
        }
        // _hmt.push(['_trackEvent', 'BaiduSite', 'Check']);
        this.items = [];
        this.isOkNum = 0;
        this.isBadNum = 0;
        this.isShow = false;
        this.$messenger.addTarget(window.parent, 'parent');
        this.$messenger.targets['parent'].send("Check-Baidu-Site");
        this.loading = true;
      },
      listenBaiduSite() {
        this.$messenger.listen("_5118_BaiduLink_NoNum", (msg) => {
          this.isBadNum = msg
        });
        this.$messenger.listen("_5118_BaiduLink_OkNum", (msg) => {
          this.isOkNum = msg
        });
        this.$messenger.listen("_5118_BaiduLink_No_Info", (msg) => {
          for (let key in msg) {
            if (msg.hasOwnProperty(key)) {
              this.$store.state.baiduSite.items.push(msg[key]);
              this.items.reverse();
            }
          }
        });
        this.$messenger.listen("_5118_BaiduLink_End", (msg) => {
          if (msg === "End") {
            this.loading = false;
          }
        });
      },
      exportList() {
        this.$messenger.targets['parent'].send("_5118_Export", "SiteBaiDu");
      }
    }
  }
</script>

<style type="text/less" lang="less" scoped>
  @import "../assets/style/color";
  @import "../assets/style/config";
  @import "../assets/style/mixin";

  .baidusite-count-table {
    width: 100%;
    border: none;
    border-top: 1px solid #ccc;
    td, th {
      border: none;
      text-align: left;
      line-height: 26px;
      font-size: 12px;
      font-weight: normal;
      &:nth-child(1) {
        width: 70%;
      }
      &:nth-child(2) {
        width: 30%;
      }
    }
  }

  .baidusite-table {
    width: 100%;
    border: none;
    border-top: 1px solid #ccc;
    td, th {
      border: none;
      text-align: left;
      line-height: 26px;
      font-size: 12px;
      font-weight: normal;
      .ellipsis();
      &:nth-child(1) {
        width: 70%;
      }
      &:nth-child(2) {
        width: 30%;
      }
    }

    td {
      &:nth-child(1) {
        color: @theme-color;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/BaiduSite.vue